/*
 * Main-grid card actions  ·  assets/hoh-card-actions.js
 *
 * Adds a dismiss "X" button to every main-gallery card on hover, using
 * the same shared dismissed list as the Fresh Faces rail. Watches for
 * dynamically rendered cards via MutationObserver so it works no matter
 * when renderGallery runs.
 *
 * Also provides the helpers the section uses to filter dismissed
 * characters out of the main grid (and to render a "Hidden" view via
 * the sort dropdown).
 *
 * Lives outside sections/hall-of-heroes.liquid so the section stays
 * under Shopify's 256 KB limit.
 */
(function(){
  'use strict';

  /* R668: the armed-label stylesheet override (R249) left with the × it
     labelled. The restore button in the Hidden view is untouched. */

  function ensureXButton(card){
    if(!card) return;
    var id = card.getAttribute('data-hero-id');
    if(!id) return;
    /* ⛔ R668 (Jan, with a screenshot of the × in a card's corner): "Remove
       the tap to hide on main hall", then, asked: "remove the X from the main
       hall entirely." On a card the × reads as CLOSE, so people tapped it
       expecting the card to shut and armed a hide instead. The main gallery
       carries no dismiss control any more. The Hidden view keeps its restore
       button below, so anything already hidden can still come back, and the
       shared dismissed list is untouched. */
    var staleX = card.querySelector('.hoh-card-dismiss');
    if(staleX && staleX.parentNode) staleX.parentNode.removeChild(staleX);
    delete card.dataset.hohXBound;
  }

  /* Returns true only when the user is actively viewing the Hidden
     sort. Outside of that view the restore button has no business
     existing — its momentary appearance during the dismiss animation
     was confusing users (they saw a green + flash on the card they
     just removed). */
  function inHiddenView(){
    var sel = document.getElementById('hoh-sort');
    return !!(sel && sel.value === 'hidden');
  }

  function ensureRestoreButton(card){
    if(!card) return;
    var id = card.getAttribute('data-hero-id');
    if(!id) return;
    /* Hard gate: only render the + restore button inside the Hidden
       sort view. Anywhere else it would visually overlap with the
       dismiss flow and read as a UI glitch. */
    if(!inHiddenView()){
      /* If a stale restore button is on this card from a previous
         render, clean it up. */
      var stale = card.querySelector('.hoh-card-restore');
      if(stale && stale.parentNode) stale.parentNode.removeChild(stale);
      delete card.dataset.hohRestoreBound;
      return;
    }
    if(card.dataset.hohRestoreBound) return;
    if(!window.hohIsDismissed || !window.hohIsDismissed(id)) return;
    card.dataset.hohRestoreBound = '1';
    var r = document.createElement('button');
    r.type = 'button';
    r.className = 'hoh-card-restore';
    r.setAttribute('aria-label', 'Restore this hero to your view');
    r.innerHTML = '&#43;';
    r.addEventListener('click', function(e){
      e.stopPropagation();
      e.preventDefault();
      if(!window.hohRestoreCharacter) return;
      window.hohRestoreCharacter(id);
      if(typeof window.hohApplyFilters === 'function') window.hohApplyFilters();
    });
    card.appendChild(r);
  }

  function processCards(scope){
    var cards = (scope || document).querySelectorAll('.hoh-card[data-hero-id]');
    cards.forEach(function(card){
      ensureXButton(card);
      ensureRestoreButton(card);
    });
  }

  /* Watch the gallery container for re-renders and process any new
     cards that appear. The gallery rebuilds innerHTML each render so
     fresh cards always start without our buttons. */
  function startObserver(){
    var grid = document.getElementById('hoh-gallery');
    if(!grid){ setTimeout(startObserver, 200); return; }
    processCards(grid);
    var mo = new MutationObserver(function(){ processCards(grid); });
    mo.observe(grid, { childList: true, subtree: false });
    /* Re-run on sort changes too. FLIP reuses DOM nodes for unchanged
       cards so the MutationObserver may not fire when the user just
       switches between Hidden / Most hearts views. We need to refresh
       which buttons render either way. */
    var sortSel = document.getElementById('hoh-sort');
    if(sortSel){
      sortSel.addEventListener('change', function(){
        setTimeout(function(){ processCards(grid); }, 50);
      });
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver);
  else startObserver();

  /* Returns true while today's bounty hunt is active (user pressed
     Start the Search and the bounty isn't solved yet). The flag
     persists in localStorage and is also flipped off on solve. */
  function isBountyHuntActive(){
    try {
      var ymd = new Date().toISOString().slice(0,10);
      return localStorage.getItem('hoh-bounty-hunting-' + ymd) === '1';
    } catch(e){ return false; }
  }

  /* Helper used by the section's renderGallery to filter dismissed
     characters before rendering. Default: hide dismissed from the
     normal grid. When sortVal === 'hidden', invert: show ONLY the
     dismissed characters so the user can manage their hidden list.
     When the daily bounty hunt is active, BYPASS the filter so the
     user can discover the bounty hero even if they previously
     dismissed it. The Hidden view is unaffected (still inverts). */
  /* Single router for What's-This lightbox row clicks.
       n=1 → submit form
       n=2 → claim a heart (stays in modal)
       n=3 → raffle simulator
       n=4 → expand + scroll to satchel */
  window.hohExp = function(n, btn){
    if(n === 2){
      if(typeof window.hohClaimPortraitHeart === 'function'){
        var icon = btn && btn.querySelector ? btn.querySelector('.hoh-explain-icon') : null;
        window.hohClaimPortraitHeart(icon, null);
      }
      return;
    }
    if(typeof window.hohCloseExplain === 'function') window.hohCloseExplain();
    if(n === 1 && typeof window.hohOpenForm === 'function'){ window.hohOpenForm(); return; }
    if(n === 3 && typeof window.hohOpenRaffle === 'function'){ window.hohOpenRaffle(); return; }
    if(n === 4){
      var p = document.querySelector('.hoh-pouch');
      if(!p) return;
      /* R136-hint-scroll: when the satchel is locked (daily seal), the
         "How it works" hints (e.g. "A coin that remembers every flip")
         should NOT call hohTogglePouch — that would either bounce off
         the lock guard (no-op) or, worse, suggest the satchel is
         openable when it isn't. Just scroll the user TO the satchel
         section so they can see the lock CTA. If the satchel is
         already unlocked, we still don't auto-open from a hint —
         opening should be a deliberate user click on the bar. */
      setTimeout(function(){ p.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120);
    }
  };

  /* Auto-attach role="button" + tabindex="0" + Enter/Space handler
     to every .hoh-explain-row-clickable so the inline HTML doesn't
     have to repeat those attributes. Runs on init + whenever the
     explain modal opens (in case markup changes). */
  function wireExplainRows(){
    document.querySelectorAll('.hoh-explain-row-clickable').forEach(function(el){
      if(el.dataset.hohWired) return;
      el.dataset.hohWired = '1';
      if(!el.getAttribute('role')) el.setAttribute('role', 'button');
      if(el.getAttribute('tabindex') === null) el.setAttribute('tabindex', '0');
    });
  }
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if(t && t.classList && t.classList.contains('hoh-explain-row-clickable')){
      e.preventDefault();
      t.click();
    }
  });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireExplainRows);
  else wireExplainRows();

  /* R318 → HALLHERO (Jan, 2026-09-23: "remove the hidden by me filter"). The
     personal X-dismiss list (local, per-device, written by Explore's X) still
     takes those heroes out of the main grid. The 'mine_hidden' view that showed
     them is gone; the grid's end offers "Show them" instead
     (hohRenderHiddenReset in hoh-section-core.js), and Explore offers Undo right
     after a hide. */
  window.hohApplyDismissFilter = function(list){
    if(!Array.isArray(list)) return list;
    if(isBountyHuntActive()) return list;
    var dismissed = (typeof window.hohGetDismissedList === 'function') ? window.hohGetDismissedList() : [];
    if(!dismissed.length) return list;
    var set = {};
    dismissed.forEach(function(id){ set[id] = true; });
    return list.filter(function(c){ return !(c && c.id && set[c.id]); });
  };
})();
